const storage = window.localStorage;

export default class Storage {
	constructor() {
		throw new Error('this class can\'t be an instance');
	}

	static get(key) {
		const storage_item = storage.getItem(key);
		const is_JSON_string = this.isJsonString(storage_item);
		return storage_item && is_JSON_string ? JSON.parse(storage.getItem(key)) : null;
	}

	static set(key, value) {
		storage.setItem(key, JSON.stringify(value));
	}

	static remove(key) {
		storage.removeItem(key);
	}

	static clear() {
		storage.clear();
	}

	static isJsonString(str) {
		try {
			JSON.parse(str);
		}
		catch (e) {
			return false;
		}
		return true;
	}
}